<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="姓名">
        <el-input v-model="queryInfo.name" clearable placeholder="请输入姓名"/>
      </el-form-item>
      <!-- <el-form-item label="申请人">
        <el-input v-model="queryInfo.applyUser" clearable placeholder="请输入申请人"/>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="queryInfo.status" clearable>
          <el-option
          v-for="item in ApprovalStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="编号">
        <el-input v-model="queryInfo.eventId" clearable placeholder="请输入编号"/>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="待处理" name="queryMine"></el-tab-pane>
        <!-- <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane> -->
        <el-tab-pane label="已处理" name="queryMyAudit"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange"
    >
      <template #operate={row}>
        <el-button type="text" size="small" @click="add(row)">{{activeName === 'queryMine' ? '处理反馈' : '查看详情'}}</el-button>
      </template>
    </table-list>
    <apply-dialog ref="Apply" @addSuccess="query"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ApplyDialog from './applyDialog.vue'
import { compIntentionFeedbackInfo } from '@/api/comprehensive'
import { ApprovalStatus } from '@/utils/constants'
export default {
  data () {
    return {
      ApprovalStatus: ApprovalStatus,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      tableData: [],
      queryInfo: {},
      loading: false,
      columnDefs: [
        { label: '姓名', prop: 'name' },
        { label: '联系电话', prop: 'mobile' },
        { label: '意向园区', prop: 'parkName' },
        { label: '备注', prop: 'remark' },
        { label: '留言时间', prop: 'createTime' },
        { label: '操作', prop: 'operate', width: 240 }
      ],
      activeName: 'queryMine'
    }
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let handleStatus = this.activeName === 'queryMine' ? 0 : 1
      compIntentionFeedbackInfo('pageListIntentionFeedback', {
        ...this.queryInfo,
        pageSize: this.pageSize,
        handleStatus: handleStatus,
        pageNum: this.page,
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (row) {
      this.$refs.Apply.getDetails(row, this.activeName)
    },
  },
  components: {
    TableList,
    ApplyDialog
  },
  mounted() {
    this.query()
  }
}
</script>
